module.exports = __webpack_public_path__ + "static/media/flag-inbound.svg";